export const blockIconsTransportationTaxiAlertNew = (
	<span className='material-symbols-outlined'>taxi_alert</span>
);
